import React, { Component } from 'react';
import { connect } from 'react-redux';
import AddPlayersTemplateModal from '../AddPlayersTemplateModal';
import { getPlayersTemplateFile } from '../../../selectors/teams';
import { aGetPlayersTemplateFileRequest, aSavePlayersTemplatePreviewRequest } from '../../../reducers';

const mapToProps = (state) => ({
  playersTemplateFile: getPlayersTemplateFile(state),
});
const actionsToProps = (dispatch) => ({
  getPlayersTemplateFileRequest: (payload) => dispatch(aGetPlayersTemplateFileRequest(payload)),
  applyPlayersTemplatePreview: (payload) => dispatch(aSavePlayersTemplatePreviewRequest(payload)),
});
class AddPlayersTemplateSection extends Component {
  componentDidMount() {
    this.props.getPlayersTemplateFileRequest();
  }

  render() {
    return (
      <AddPlayersTemplateModal
        playersTemplateFile={this.props.playersTemplateFile}
        applyPlayersTemplatePreview={this.props.applyPlayersTemplatePreview}
        leagues={this.props.leagues}
        setOpenModal={this.props.setOpenModal}
        activeModal={this.props.activeModal}
        closeModal={this.props.closeModal}
        titleName="New Teams Template"
        selectDescription="Select the competition to apply teams template"
        saveBtnLabel="Preview"
      />
    );
  }
}
export default connect(mapToProps, actionsToProps)(AddPlayersTemplateSection);
